import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiPaymentTypeQueryResponse,
  GetApiPaymentType401,
  GetApiPaymentType403,
} from "../../../types/GetApiPaymentType";

export function getGetApiPaymentTypeUrl() {
  return `/api/Payment/type` as const;
}

/**
 * {@link /api/Payment/type}
 */
export async function getApiPaymentType(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiPaymentTypeQueryResponse,
    ResponseErrorConfig<GetApiPaymentType401 | GetApiPaymentType403>,
    unknown
  >({
    method: "GET",
    url: getGetApiPaymentTypeUrl().toString(),
    ...requestConfig,
  });
  return res;
}
